// eslint-disable-next-line import/prefer-default-export
export const initialState = {
  products: false,
  singleProduct: false,
  deleteProduct: false,
  associations: false,
  singleAssociation: false,
  deleteAssociation: false,
  addAssociation: false,
  accessories: false,
  addAccessory: false,
  nestedAccessories: false,
  calculate: false,
  deleteContent: false,
  color: false,
  type: false,
  height: false,
  posts: false,
  panels: false,
};
